import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import api from "@/lib/api";
import RecepcionPanel from "@/components/traspasos/RecepcionPanel";

/** Compatibilidad: prepara el traspaso para el panel de recepción (el avance guardado se retoma automáticamente). */
export const prepararRecepcion = (tr) => ({ ...tr });

export default function RecibirDialog({ recibir, setRecibir, onDone, onClose }) {
  const [fresco, setFresco] = useState(null);
  useEffect(() => {
    if (!recibir?.id) { setFresco(null); return; }
    let vivo = true;
    api.get(`/traspasos/${recibir.id}`).then((r) => { if (vivo) setFresco({ ...recibir, ...r.data }); }).catch(() => { if (vivo) setFresco(recibir); });
    return () => { vivo = false; };
  }, [recibir]);
  const cerrar = () => { setRecibir(null); onClose?.(); };
  return (
    <Dialog open={!!recibir} onOpenChange={cerrar}>
      <DialogContent className="max-w-3xl w-[96vw] p-0 rounded-2xl overflow-hidden gap-0 [&>button]:hidden" data-testid="receive-dialog" aria-describedby={undefined}>
        <DialogTitle className="sr-only">Recibir pedido</DialogTitle>
        {recibir && !fresco && <div className="p-10 flex items-center justify-center gap-2 text-sm text-brand-muted" data-testid="recepcion-cargando"><Loader2 className="w-4 h-4 animate-spin" /> Cargando pedido…</div>}
        {recibir && fresco && <RecepcionPanel key={fresco.id} traspaso={fresco} modoInicial={recibir.escaner ? "escaner" : fresco.recepcion_avance?.modo || "manual"} onClose={cerrar} onDone={(d) => { setRecibir(null); onDone?.(d); }} />}
      </DialogContent>
    </Dialog>
  );
}
